import React, {Component} from 'react';
import {connect} from 'react-redux'
import cn from 'classnames'
import {withStyles} from 'material-ui/styles';
import MenuListItem from './MenuListItem'
import flow from 'lodash/flow'
import {getPermissions} from '../../selectors'
import {PERMISSIONS} from '../../models/enums'
import {hasPermission} from '../../utils/permissions'
import filter from 'lodash/filter'

import SettingsIcon from 'material-ui-icons/Build'
import NotificationIcon from 'material-ui-icons/Notifications'
import SitesIcon from 'material-ui-icons/Domain'
import HelcopterIcon from 'material-ui-icons/Flight'

class MenuItems extends Component
{

    render() {
        const {classes, className, permissions} = this.props;

        const adminMenuItems = filter([
            hasPermission(permissions, PERMISSIONS.ViewJobs) && <MenuListItem first className='small' key={2} title="Jobs" subtitle="Notification and Vegetation Import" link="/admin/jobs" icon={<NotificationIcon />} />,
            hasPermission(permissions, PERMISSIONS.EditSite) && <MenuListItem className='small' key={3} title="Sites" subtitle="Sites with pre-existing trees" link="/admin/sites" icon={<SitesIcon />}/>,
            hasPermission(permissions, PERMISSIONS.EditSite) && <MenuListItem title="Vegetation Import" key={4} link="/admin/helicopter-data" className='small' icon={<HelcopterIcon />}/>,
            hasPermission(permissions, PERMISSIONS.ClientConfiguration) && <MenuListItem key={1} className='small' title="Settings" subtitle="" link="/admin/client-configuration" icon={<SettingsIcon />} />,
        ], x => x);

        return <ul className={cn(classes.root, className)}>
            {hasPermission(permissions, PERMISSIONS.SearchSites) &&
            <MenuListItem title="Sites" subtitle="Search for addresses" link="/"/>}
            {hasPermission(permissions, PERMISSIONS.SearchSiteInspections) &&
            <MenuListItem title="Inspections" subtitle="Search for vegetation inspections" link="/search"/>}
            {hasPermission(permissions, PERMISSIONS.AddUser) && <MenuListItem title="Users" subtitle="Manage users and roles" link="/users" />}
            {hasPermission(permissions, PERMISSIONS.ViewSiteInspectionReview) && <MenuListItem title="Reviews" subtitle="visualize reviews of inspection" link="/viewreview" />}
            {adminMenuItems.length > 0 && <MenuListItem link="/admin" title="Admin" subtitle="" >
                    <ul>
                        {adminMenuItems}
                    </ul>
                </MenuListItem>
            }
            {hasPermission(permissions, PERMISSIONS.ViewForms) && <MenuListItem title="Forms" subtitle="View and create forms" link="/forms" />}
        </ul>
    }
}

const mapStateToProps = (state) => {
    return {
        permissions: getPermissions(state)
    }
};

export default flow([
    connect(mapStateToProps),
    withStyles(() => ({
        root: {
        },
    }))
])(MenuItems)



// WEBPACK FOOTER //
// ./src/components/Menu/MenuItems.js